/**
 * Retorna `true` se `x` for maior ou igual a `y`.
 *
 * @param {number|string} x
 * @param {number|string} y
 * @returns {boolean}
 */
export function gte(x, y) {
  return Number(x) >= Number(y);
}
